import { Switch, SwitchProps } from '@mui/material';

export function BaseSwitch({ ...otherProps }: SwitchProps) {
  return <Switch {...otherProps} />;
}
